/*
 * @Description:
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2020-06-22 10:57:39
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2025-09-10 16:35:41
 */
let apiUrl='',uploadUrl='';
let uploadUrlTwo="";
const imgShow=`https://files.mankoo.cn/`
// 当前环境
const env = process.env.PATH_ENV;
uploadUrl = 'https://api.accountsir.com/workflow/fileManager/uploadFiles';
uploadUrlTwo ='https://api.accountsir.com/workflow/fileManager/uploadFilesTwo'
apiUrl = {
	// *********** 好账先生 ********************************
    'haozhang':"//192.168.1.9:9008/billing/",  //测试
	// 'haozhang':"https://api.haozhang.vip/", //正式
	// 'haozhang':"//192.168.1.228:8068/", //郑
	// 'haozhang':"//192.168.1.150:8086/", //达
	//  'haozhang':"//192.168.1.253/", //熊/0
	// 'haozhang':"//192.168.1.12:8082/", //黄
	// 'haozhang':"//60.205.228.199:8080/billing/", //预正式
	// *********** 记账后台 ********************************
	// 'houtai':"//192.168.1.36:8033/",  //郑
	//  'houtai':"//192.168.1.9:9001/accmanager/",
	'houtai':"https://api.accountsir.com/accmanager/",  //正式

	// *********** webSocket ********************************
	// "socketUrl":"ws://192.168.1.254:8080/socket"
	// "socketUrl":"wss://websocket.accountsir.com/socket"
	"socketUrl":"ws://192.168.1.9:9001/webSocket/socket"
}
// 测试环境下的请求地址配置
if (env === 'test') {
	uploadUrl = 'https://api.accountsir.com/workflow/fileManager/uploadFiles';   // 上传地址
	uploadUrlTwo ='https://api.accountsir.com/workflow/fileManager/uploadFilesTwo'
	// uploadUrl = 'http://192.168.1.9:9001/workflow/fileManager/uploadFilesTwo'
	apiUrl = {
		// *********** 好账先生 ********************************
		'haozhang':"//192.168.1.9:9008/billing/",  //测试

		// *********** 记账后台 ********************************

		'houtai':"//192.168.1.9:9001/accmanager/",  //测试

		// *********** webSocket ********************************
		"socketUrl":"ws://192.168.1.9:9001/webSocket/socket"
	}
}else if (env === 'prod') { // 正式环境下的请求地址配置
	uploadUrl = 'https://api.accountsir.com/workflow/fileManager/uploadFiles';   // 上传地址
	uploadUrlTwo ='https://api.accountsir.com/workflow/fileManager/uploadFilesTwo'
	apiUrl = {
		// *********** 好账先生 ********************************
		'haozhang':"https://api.haozhang.vip/", //正式

		// *********** 记账后台 ********************************

		'houtai':"https://api.accountsir.com/accmanager/",  //正式

		// *********** webSocket ********************************
		"socketUrl":"wss://websocket.accountsir.com/socket"
	}
}else if (env === 'pre') { // 正式环境下的请求地址配置
	uploadUrl = 'https://api.accountsir.com/workflow/fileManager/uploadFiles';   // 上传地址
	uploadUrlTwo ='https://api.accountsir.com/workflow/fileManager/uploadFilesTwo'
	apiUrl = {
		// *********** 好账先生 ********************************
		'haozhang':"//60.205.228.199:8080/billing/",  //测试

		// *********** 记账后台 ********************************

		'houtai':"//192.168.1.9:9001/accmanager/",  //测试

		// *********** webSocket ********************************
		"socketUrl":"ws://192.168.1.9:9001/accmanager/socket"
	}
}

export { apiUrl,uploadUrl,imgShow,uploadUrlTwo }



// WEBPACK FOOTER //
// ./src/assets/js/apiConfig.js